import { AbsolutePath } from "@kform/core";

/**
 * Error thrown when attempting to access the context of a form when no form is
 * in context.
 */
export class NoFormContextError extends Error {
  constructor() {
    super("No form context found");
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when attempting to access a form value but no form is in context
 * and no form manager was provided via an option.
 */
export class NoFormManagerError extends Error {
  constructor() {
    super("No form manager found");
    this.name = this.constructor.name;
  }
}

/**
 * Error thrown when attempting to access the controller of a form but no form
 * controller is in context.
 */
export class NoFormControllerError extends Error {
  constructor() {
    super("No form controller found");
    this.name = this.constructor.name;
  }
}

/**
 * Error occurring at a certain path.
 */
export class PathError extends Error {
  constructor(path: AbsolutePath, message: string) {
    super(`At '${path.toString()}': ${message}`);
    this.name = this.constructor.name;
  }
}
